import { render, staticRenderFns } from "./wheelSeed.vue?vue&type=template&id=251e0afd&scoped=true"
import script from "./wheelSeed.vue?vue&type=script&lang=js"
export * from "./wheelSeed.vue?vue&type=script&lang=js"
import style0 from "./wheelSeed.vue?vue&type=style&index=0&id=251e0afd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e0afd",
  null
  
)

export default component.exports